// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4569":"90af1c335bdf6352","5310":"513eabe8355a9138"}[chunkId] + ".css";
};